import Navbar from './../src/Components/Navbar';
import HeaderLogin from './../src/Components/HeaderLogin';
import Footer from './../src/Components/Footer';


import React, { Component } from 'react'

export default class Layout extends Component {
  constructor(props) {
    super(props);
    this.state = {

    }
  }
  render() {
    return (
      <div>
        <HeaderLogin></HeaderLogin>
        <Navbar />
        {this.props.children}
        <Footer />
      </div>
    )
  }
}


